import "./BalanceWindow.css"
import React from "react"
import { observer } from "mobx-react"
import Window from "./Window"

const BalanceWindow = ({ title, traits, size }) => {
  const width = Math.min(size.width - 40, 800)
  return (
    <Window
      title={title.toUpperCase()}
      width={width}
      height={450}
      className="BalanceWindow"
    >
      <div className="BalanceWindow__content">
        <div className="BalanceWindow__list">
          <ol>
            {traits.map((t, i) => (
              <li key={i}>
                <strong style={{ textTransform: "uppercase" }}>{t.name}</strong>:{" "}
                {t.definition}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </Window>
  )
}

export default observer(BalanceWindow)



// WEBPACK FOOTER //
// ./src/components/BalanceWindow.js